import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Grid2 } from "@mui/material";
import axios from "axios";
import { XMLParser } from "fast-xml-parser";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let regions = ["ne", "cat", "phx"];
let series = [];

function FacebookMarketingAds(mode) {
	const [focusRegion, setFocusRegion] = React.useState("");
	const [focusSeries, setFocusSeries] = React.useState("");
	const [serieAPI, setSeriesAPI] = React.useState([]);
	const [regionJSON, setRegionJSON] = React.useState([]);

	React.useEffect(() => {
		if (focusRegion) {
			loadSeriesAPI();
		}
	}, [focusRegion]);
	// React.useEffect(() => {
	// 	console.log("regionJSON updated");
	// 	console.log(regionJSON);
	// 	if (focusSeries) {
	// 		console.log("running offer data");
	// 		getOfferData();
	// 	}
	// }, [regionJSON]);

	React.useEffect(() => {
		console.log("----- ", focusRegion, focusSeries);
		if ((focusRegion, focusSeries)) {
			loadFBCatalogAdsXML(focusRegion, focusSeries);
		}
	}, [focusRegion, focusSeries]);
	async function getOfferData(json) {
		console.log("getOfferData");
		console.log(json.listings);
		console.log(json.listings.listing.length);
		document.getElementById("ads").innerHTML = "No offers found";
		for (let i = 0; i < json.listings.listing.length; i++) {
			console.log(json.listings.listing[i].model, focusSeries);
			// console.log(json.listings.listing[i].model == focusSeries);

			if (json.listings.listing[i].model == focusSeries) {
				//clear all tags in ads
				console.log(json.listings.listing[i].model, focusSeries);
				document.getElementById("ads").innerHTML = "";
				//build images
				console.log(
					"json.listings.listing[i].image.url",
					json.listings.listing[i].image.url
				);

				//for (var u = 0; u < json.listings.listing[i].image.length; u++) {
				//loadImages(json.listings.listing[i]);

				var image = document.createElement("img");
				var adDiv = document.createElement("div");
				var adA = document.createElement("a");
				adA.href = json.listings.listing[i].url;
				adA.target = "_blank";
				adDiv.appendChild(adA);
				adDiv.classList.add("fbCatAdDiv");

				image.src = json.listings.listing[i].image.url;
				image.classList.add("fbCatImg");
				document.getElementById("ads").appendChild(adDiv);
				adA.appendChild(image);
				//}
				// for (var u = 0; u < json.listings.listing[i].image.length; u++) {
				// 	//loadImages(json.listings.listing[i]);
				// 	console.log(json.listings.listing[i].image[u].url);
				// 	var image = document.createElement("img");
				// 	var adDiv = document.createElement("div");
				// 	var adA = document.createElement("a");
				// 	adA.href = json.listings.listing[i].url;
				// 	adA.target = "_blank";
				// 	adDiv.appendChild(adA);
				// 	adDiv.classList.add("fbCatAdDiv");

				// 	image.src = json.listings.listing[i].image[u].url;
				// 	image.classList.add("fbCatImg");
				// 	document.getElementById("ads").appendChild(adDiv);
				// 	adA.appendChild(image);
				// }
				//if fbCatMetaDiv exists already remove it
				if (document.getElementById("fbCatMetaDiv")) {
					document.getElementById("fbCatMetaDiv").remove();
				}

				var metaDiv = document.createElement("div");

				metaDiv.id = "fbCatMetaDiv";
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].title,
					"Title"
				);
				metaDiv.innerHTML += datacombine(json.listings.listing[i].year, "Year");
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].offer_description,
					"Offer Description"
				);
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].price,
					"Price"
				);
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].vehicle_offer_id,
					"Vehicle Offer ID"
				);
				metaDiv.innerHTML += datacombine(json.listings.listing[i].make, "Make");
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].model,
					"Model"
				);
				metaDiv.innerHTML += datacombine(json.listings.listing[i].trim, "Trim");
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].offer_type,
					"Offer Type"
				);
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].url,
					"Clickthrough"
				);
				if (json.listings.listing[i].offer_type == "finance") {
					// metaDiv.innerHTML += datacombine(
					// 	json.listings.listing[i].amount_percentage,
					// 	"Amount Percentage"
					// );
					// metaDiv.innerHTML += datacombine(
					// 	json.listings.listing[i].term_length,
					// 	"Term Length"
					// );
				} else if (json.listings.listing[i].offer_type == "lease") {
					// metaDiv.innerHTML += datacombine(
					// 	json.listings.listing[i].amount_price,
					// 	"Amount Price"
					// );
					// metaDiv.innerHTML += datacombine(
					// 	json.listings.listing[i].amount_qualifier,
					// 	"Amount Qualifier"
					// );
					// metaDiv.innerHTML += datacombine(
					// 	json.listings.listing[i].term_length,
					// 	"Term Length"
					// );
					// metaDiv.innerHTML += datacombine(
					// 	json.listings.listing[i].downpayment,
					// 	"Downpayment"
					// );
					// metaDiv.innerHTML += datacombine(
					// 	json.listings.listing[i].downpayment_qualifier,
					// 	"Downpayment Qualifier"
					// );
				}
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].offer_disclaimer,
					"Disclaimer"
				);
				var dmaHTML = `<span><b>DMA Codes:</b> `;

				for (var d = 0; d < json.listings.listing[i].dma_codes.length; d++) {
					dmaHTML += datacombine(json.listings.listing[i].dma_codes, "");
				}
				dmaHTML += "</span>";
				metaDiv.innerHTML += dmaHTML;
			}
			document.getElementById("ads").append(metaDiv);
		}
	}
	function datacombine(data, label) {
		var html = "";
		if (data) {
			// if data is an array
			if (Array.isArray(data)) {
				for (var i = 0; i < data.length; i++) {
					html += `<span><b>${label}:</b> ${data[i]}</span>`;
				}
			} else {
				html = `<span><b>${label}:</b> ${data}</span>`;
			}
		} else {
			if (label != "Title") {
				html = `<span class="fbdataerror"><b>${label}:</b> ${data} is missing</span>`;
			} else {
				html = `<span><b>${label}:</b> ${data} is empty but its ok</span>`;
			}
		}
		return html;
	}
	async function loadSeriesAPI() {
		const response = await fetch(
			`https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/seriesapi/full/${focusRegion}/seriesapi.json`
		);
		var data = await response.json();
		data = data.filter((item) => item.status !== "paused");

		setSeriesAPI(data);
		console.log(series);
	}
	async function loadFBCatalogAdsXML(focusRegion, focusSeries) {
		var xml = "";

		await getLiveXML(focusRegion);
	}

	async function getLiveXML(region) {
		console.log("getLiveXML");

		//fetch xml files at https://xmlconverter.datcdn.com/phx_facebook_nf_2.xml
		axios
			.get(
				`https://dat-sync.com/assets/${region}/social/fb/fb_marketing_feed_${region}.xml`
			)
			.then((response) => {
				console.log(response.data);
				const parser = new XMLParser();
				const json = parser.parse(response.data);
				setRegionJSON(json);
				console.log(json);
				getOfferData(json);
			})
			.catch((error) => {
				console.error("There was an error!", error);
			});
	}

	return (
		<div id="htmlPage">
			<h1>Facebook Marketing Ads</h1>
			<Grid2 container spacing={2} direction="column">
				<FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="region-select-label">Region</InputLabel>
					<Select
						labelId="region-select-label"
						id="region-select"
						value={focusRegion ? focusRegion : ""}
						onChange={(e) => setFocusRegion(e.target.value)}
						input={<OutlinedInput label="Region" />}
						MenuProps={MenuProps}
					>
						{regions.map((region) => (
							<MenuItem key={region} value={region}>
								<ListItemText primary={region} />
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="series-select-label">Series</InputLabel>
					<Select
						labelId="series-select-label"
						id="series-select"
						value={focusSeries ? focusSeries : ""}
						onChange={(e) => setFocusSeries(e.target.value)}
						input={<OutlinedInput label="Series" />}
						MenuProps={MenuProps}
					>
						{serieAPI.map((serie) => (
							<MenuItem key={serie.seriesname} value={serie.seriesname}>
								<ListItemText primary={serie.seriesname} />
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid2>
			<Grid2 container spacing={2} id="ads"></Grid2>
		</div>
	);
}

export default FacebookMarketingAds;
